import * as Sentry from '@sentry/react'
import type { Stripe } from '@stripe/stripe-js'
// The default entry injects Stripe.js on import (every page); `pure` waits for the first call.
import { loadStripe } from '@stripe/stripe-js/pure'

const stripePublicApiKey: string = import.meta.env.VITE_STRIPE_PUBLIC_API_KEY

let stripe: Promise<Stripe | null> | undefined

export function getStripe() {
  stripe ??= loadStripe(stripePublicApiKey).catch((error: unknown) => {
    // Usually a blocker, offline client or bot; resolved as unavailable instead of an unhandled rejection.
    Sentry.captureException(error, {
      level: 'warning',
      tags: { feature: 'payment', operation: 'load_stripe' },
    })
    return null
  })
  return stripe
}
